import React, { useState, useContext, useEffect } from 'react'
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Button, InputGroup, InputGroupText, Alert, } from "reactstrap";
import { AppContext } from '../../AppContext';
import Hide from '../../assets/img/icon/hide.png'
import View from '../../assets/img/icon/view.png'
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../constants';
import Logo from '../../assets/img/inspectalyLogo.png'

const Login = () => {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [errMsg, setErrMsg] = useState(null);
    const { updateUserData } = useContext(AppContext);
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();

    // const handleLogin = () => {
    //     if (email != '' && pass != '') {
    //         const userData = {
    //             email: email,
    //             password: pass
    //         };
    //         updateUserData(userData);
    //     } else {
    //         setErrMsg('Please fill in all fields');
    //     }
    // };

    const handleLogin = async () => {
        if (email !== '' && pass !== '') {
            try {
                const response = await axios.post(`${BASE_URL}/auth/login`, {
                    email: email,
                    password: pass
                });

                console.log(response.data.result, 'pak')
                localStorage.setItem('userData', JSON.stringify(response.data.result));
                updateUserData(response.data.result);
                const { authToken } = response.data.result;
                localStorage.setItem('token', authToken);
                navigate('/dashboard');

            } catch (error) {
                setErrMsg('Invalid email or password');
            }
        } else {
            setErrMsg('Please fill in all fields');
        }
    };

    const show = () => {
        if (visible === false) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     if (token) {

    //         navigate('/dashboard');
    //     }
    // }, []);

    return (
        <div style={{  minHeight: '100vh', background: 'rgb(244, 243, 239)', paddingTop: '2%' }} >
            <div style={{ display: 'flex', justifyContent: 'center'}}>
                <img src={Logo} alt="Logo" width="250" height="auto" draggable="false" />
            </div>
            <Card
                style={{
                    width: '90%', 
                    maxWidth: '30rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    padding: '20px',
                    paddingBottom: '40px',
                    marginBottom: '0px'   
                }}>
                {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

                <CardBody>
                    <CardTitle tag="h3" className='text-center mb-4'>
                        Login
                    </CardTitle>
                    <CardTitle>Email</CardTitle>
                    <InputGroup>
                        <input type="email" className="form-control user-select-none" autoFocus
                            value={email} onChange={(e) => setEmail(e.target.value)} />
                    </InputGroup>
                    <CardTitle>Password</CardTitle>
                    <InputGroup>
                        <input type={!visible ? "password" : "text"} className="form-control user-select-none"
                            onKeyPress={(e) => { e.key === "Enter" && handleLogin() }}
                            value={pass} onChange={(e) => setPass(e.target.value)} />
                        <InputGroupText onClick={show} className='user-select-none'>
                            {!visible ?
                                <img src={Hide} alt="" srcset="" height={20} draggable="false" /> :
                                <img src={View} alt="" srcset="" height={20} draggable="false" />}
                        </InputGroupText>
                    </InputGroup>
                </CardBody>
                <Row className='mb-3'>
                    <Col className='d-flex justify-content-end' >
                        <Link to="/forgot-password">Forgot Password</Link>
                    </Col>
                </Row>
                <CardFooter>
                    <Row className='text-center'>
                        <Col >
                            <Button color="primary" className='px-5' size="md" onClick={handleLogin} >Login</Button>
                        </Col>
                    </Row>
                </CardFooter>
                <Row className='mt-3'>
                    <Col className='d-flex justify-content-center'>
                        Don't Have An Account?&nbsp;<Link to="/register">Register</Link>
                    </Col>
                </Row>
            </Card>

        </div>
    )
}

export default Login
